import { ThreeDotMenuItem } from "components/ThreeDotMenu";

export const menuItems = (
  published: boolean,
  deleteRecipe: () => void,
  onPublishUnpublishClicked: () => void
): ThreeDotMenuItem[] => [
  {
    label: published ? "Unpublish" : "Publish",
    onClick: onPublishUnpublishClicked,
  },
  {
    label: "Delete",
    onClick: deleteRecipe,
    className: "text-red-500",
  },
];
